import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/actions/auth.action';

export default function SearchCategory({ updateCategory=null, item=null, defaultValue=null }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [q, setQ] = useState("");
    const [category, setCategory] = useState(defaultValue);
    const [categories, setCategories] = useState([]);

    const searchCategories = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }categories/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setCategories(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchCategories();
    }, [searchCategories, location]);

    useEffect(() => {
        if(q.length >= 2){
            searchCategories(q);
        }
    }, [searchCategories, q]);
    
    useEffect(() => {
        setQ("");
        if(updateCategory && category){
            updateCategory(category);
        }
    }, [updateCategory, category]);

    useEffect(() => {
        setCategory(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <div className='autocomplete'>
            <label htmlFor={ `category_id${ item !== null ? '_' + item : '' }` } className='form-control'>{ category ? category.name : 'Rechercher une catégorie' }</label>
            <input type='text' ref={ autocompleteInputRef } onFocus={ () => {
                setIsAutocompleteOpen(true);
            }} id={ `category_id${ item !== null ? '_' + item : '' }` } placeholder={ category ? category.name : 'Rechercher une catégorie' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } />
            <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                { categories.map(item => {
                    return(
                        <li key={ item.id } onClick={ () => {
                            setCategory(item);
                            setIsAutocompleteOpen(false);
                        } }><i className='fa fa-search'></i> { item.name }</li>
                    )
                }) }
                { categories.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
            </ul>
        </div>
    )
}
